module.exports = __webpack_public_path__ + "img/vicks_dayquil_cold_flu_liquid.40d95429.gif";